import React from "react";
import cx from "classnames";
import styles from "./DevTools.module.css";

/**
 * Reusable tab button component for DevTools panel.
 * @param {Object} props
 * @param {boolean} [props.active] - Whether this tab is currently active
 * @param {Function} props.onClick - Click handler
 * @param {React.ReactNode} props.children - Tab label content
 * @param {string} [props.title] - Tooltip text
 * @param {boolean} [props.icon] - Whether this is an icon-only tab (smaller padding)
 * @param {boolean} [props.noBorder] - Whether to remove the right border
 */
const TabButton = ({ active = false, onClick, children, title, icon = false, noBorder = false }) => (
  <button
    type="button"
    className={cx(styles.tab, {
      [styles.tabActive]: active,
      [styles.tabIcon]: icon,
      [styles.tabNoBorder]: noBorder,
    })}
    onClick={onClick}
    title={title}
  >
    {children}
  </button>
);

export default TabButton;
